import { render, staticRenderFns } from "./dropdown.vue?vue&type=template&id=2abf5c4d&lang=pug"
import script from "./dropdown.vue?vue&type=script&lang=ts"
export * from "./dropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports